// Used in face verify route to identify re-direct from tencent after face process
export enum FaceVerifyScreens {
  /** This is for can't access old phone in update phone flow */
  UPDATE_PHONE = 'up',
  RESET_PIN = 'rp',
  /** This is actual face verification in update phone flow */
  UPDATE_PHONE_2 = 'up2'
}
// ^ if any changes made to this, make relative chagnes in backend tencent service.
